import React, { useEffect, useContext } from 'react';
import { CornerLeftUp, CornerRightUp } from 'lucide-react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import './style.css';
import { WindowSizeContext } from '/src/App';
import HelmetProvider from '/src/Components/HelmetProvider/HelmetProvider';
import OurPromise from './OurPromise/OurPromise';
import StandardButton from '/src/Components/StandardButton/StandardButton';
import UnderConstruction from '/src/Components/UnderConstruction/UnderConstruction';

const WhyFree = () => {
    // Update the page title to "Why Is Quoll Free?"
    // useEffect(() => {
    //     document.title = "Why Is Quoll Free?";
    // }, []);

    const { deviceType } = useContext(WindowSizeContext);
    const pageTitle = "Why Is Quoll Free?"

    const header = "Quoll is Free Because We've Been in Your Shoes"

    const sections = [
        {
            image: "quoll-why-free-family-home.webp",
            text: "We’ve felt the stress that comes when climate risk becomes personal — when a storm, wildfire, or flood damages your home and suddenly your savings, insurance, and peace of mind are all at stake.<br/><br/>Like millions of homeowners, we discovered how hard it is to get clear, reliable information before disaster hits — and how little help there is when you need it most.",
            tag: "This is why we developed the technology",
            arrow: "left"
        },
        {
            image: "quoll-what-you-are-up-against.webp",
            text: "We also learned the unfortunate truth: many of the companies homeowners rely on aren’t built to help you prepare — they’re built to help you recover, often after the damage (and costs) are already done.<br/><br/>That realization made us determined to change how homeowners access risk and resilience information — to make it transparent, practical, and free for everyone.",
            tag: "This is why we give it to you for free",
            arrow: "right"
        }
    ]

    const section2Title = "How a Free Climate Risk Tool Like Quoll Makes Money"
    const section2Text = "When homeowners are educated about their climate risk and motivated to reduce it, everyone wins. Banks, insurers, and home improvement providers all want to work with proactive homeowners who are planning ahead — so they compete to offer better prices, better products, and better support. That means you benefit first. To learn more about how our analysis identifies your best project options check out our <a href='/about/methodology'>Methodology</a> page."


    const howItWorksSections = [
        {
            step: 1,
            image: "quoll-why-free-make-you-an-expert.svg",
            text: "We help you become an expert on your home’s climate risks and the practical steps to protect it. That knowledge puts you in control — understanding where your home is most exposed and what improvements make the biggest financial and safety impact.",
        },
        {
            step: 2,
            image: "quoll-why-free-companies-compete-over-you.svg",
            text: "Once you understand your risks, companies compete to earn your business. Whether it’s a home improvement contractor, an insurer offering premium discounts, or a lender helping finance upgrades, they know you’re motivated and informed — the best kind of customer.",
        },
        {
            step: 3,
            image: "quoll-why-free-companies-pay.svg",
            text: "When you choose to work with those companies, they pay us — not you. There’s no markup, hidden cost, or obligation. You’re never charged a dime for using the platform or exploring your options.",
        }
    ]

    const privacyHeader = "Your Privacy Comes First"
    const privacyParagraph = "We believe transparency builds trust — especially when it comes to your data. When you enter your address, our system uses publicly available property data to show your home’s risks and costs. You’re always in control of what you choose to share, and your personal information is never sold or shared with advertisers. Read our full <a href='/privacy/privacy-policy'>Privacy Policy</a> and <a href='/privacy/terms-and-conditions'>Terms & Conditions</a> to learn how we protect your data and keep your information secure."

    const buttonsArray = [
        {
            text: "Privacy Policy",
            link: "/privacy/privacy-policy"
        },
        {
            text: "Terms & Conditions",
            link: "/privacy/terms-and-conditions"
        }
    ]

    return (
        <>
            <HelmetProvider
                pageType="whyFree"
            />
            <div className="static-page-content-frame">
                {/* <UnderConstruction /> */}
                <h1>{header}</h1>
                <div className={`whyfree-section-container ${deviceType}`}>
                    <div className={`whyfree-sections-row ${deviceType}`}>
                        {sections.map((section, idx) => (
                            <div className="whyfree-section" key={idx}>
                                <img
                                    className="whyfree-image"
                                    src={CreateCloudfrontUrl(section.image)}
                                    alt={section.tag}
                                />
                                <p className="whyfree-text" dangerouslySetInnerHTML={{ __html: section.text }} />
                                <div className="whyfree-bottom-block">
                                    {section.arrow === 'left' ? (
                                        <CornerLeftUp className="whyfree-arrow" />
                                    ) : (
                                        <CornerRightUp className="whyfree-arrow" />
                                    )}
                                    <div className="whyfree-tag">
                                        <strong>{section.tag}</strong>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <OurPromise />
                <div className={`meet-quoll-button-links ${deviceType}`}>
                    {buttonsArray.map((button, index) => (
                        <StandardButton
                            id={`why-free-button-${index}`}
                            text={button.text}
                            link={button.link}
                        />
                    ))}
                </div>
                {/* <div className="horizontal-divider" />
                <div className="whyfree-section-container">
                    <h2>{section2Title}</h2>
                    <div className={`whyfree-how-it-works-row ${deviceType}`}>
                        {howItWorksSections.map((section, idx) => (
                            <div className={`whyfree-how-it-works-section ${deviceType}`} key={idx}>
                                <div className="whyfree-how-it-works-step">{section.step}</div>
                                <div className={`whyfree-how-it-works-image-container ${deviceType}`}>
                                    <img src={CreateCloudfrontUrl(section.image)} alt={section.text} />
                                </div>
                                <span className="whyfree-how-it-works-text">{section.text}</span>
                            </div>
                        ))}
                    </div>
                    <p className="text-align-center" dangerouslySetInnerHTML={{ __html: section2Text }} />
                </div>
                <div className="horizontal-divider" />
                <div className="whyfree-section-container">
                    <h2>{privacyHeader}</h2>
                    <p className="text-align-center" dangerouslySetInnerHTML={{ __html: privacyParagraph }} />
                </div> */}
            </div>
        </>
    );
};

export default WhyFree;
